import {
  IconMaintenance,
  Card,
  GreyGrey10,
  GreyGrey70,
  GreyGrey90,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'

export const NoConfiguration = () => {
  return (
    <Box width="100%">
      <Card width="100%">
        <Flex
          height="160px"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          borderRadius="8px"
          backgroundColor={GreyGrey10}
          gap="12px"
        >
          <IconMaintenance size={24} color={GreyGrey70} />
          <Box {...Primary13Regular} color={GreyGrey90}>
            This connector does not have any configuration.
          </Box>
        </Flex>
      </Card>
    </Box>
  )
}
